import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseCollapse from './HseCollapse.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseCollapse;

/* template */
var __vue_render__ = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4, _obj$5, _obj$6;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Collapse",class:( _obj = {}, _obj[("hse-Collapse_color_" + _vm.color)] = _vm.color, _obj['hse-Collapse_isOpen'] =  _vm.innerIsOpen, _obj['hse-Collapse_hasMargin'] =  _vm.hasMargin, _obj[("hse-Collapse_variant_" + _vm.variant)] = _vm.variant, _obj ),attrs:{"aria-expanded":String(_vm.innerIsOpen)}},[_c('button',{staticClass:"hse-Collapse__header",class:( _obj$1 = {}, _obj$1[_vm.classes.header] = _vm.classes.header, _obj$1 ),attrs:{"tabindex":"0","type":"button"},on:{"click":_vm.onClick}},[_c('span',{staticClass:"hse-Collapse__titleBlock",class:( _obj$2 = {}, _obj$2[_vm.classes.titleBlock] = _vm.classes.titleBlock, _obj$2 )},[_c('span',{staticClass:"hse-Collapse__title",class:( _obj$3 = {}, _obj$3[_vm.classes.title] = _vm.classes.title, _obj$3 )},[_vm._t("title",[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])],2),_vm._v(" "),_c('HseIcon',{staticClass:"hse-Collapse__toggleIcon",class:( _obj$4 = {}, _obj$4[_vm.classes.toggleIcon] = _vm.classes.toggleIcon, _obj$4 ),attrs:{"icon":_vm.toggleIcon,"size":"medium"}})],1)]),_vm._v(" "),_c('div',{staticClass:"hse-Collapse__contentWrapper",class:( _obj$5 = {}, _obj$5[_vm.classes.contentWrapper] = _vm.classes.contentWrapper, _obj$5 )},[_c('div',{staticClass:"hse-Collapse__content",class:( _obj$6 = {}, _obj$6[_vm.classes.content] = _vm.classes.content, _obj$6 )},[_vm._t("default",[_vm._v("\n        "+_vm._s(_vm.content)+"\n      ")])],2)])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
